import type { GraphCanonicalEntity, GraphEntityType } from "@salesko/contracts";
import type { Dictionary } from "../../i18n";
import { entityLabel } from "../i18n";
import type { DetailTab } from "../types";

const registryViewEntityTypes = {
  companies: "organisation",
  events: "event",
  people: "person",
  signals: "opportunity"
} satisfies Record<string, GraphEntityType>;

export function isCanonicalRegistryView(viewId: string) {
  return viewId === "overview" || viewId in registryViewEntityTypes;
}

export function canonicalRegistryEntityTypeForView(viewId: string): GraphEntityType | undefined {
  return registryViewEntityTypes[viewId as keyof typeof registryViewEntityTypes];
}

export function canonicalRegistryViewForDetailTab(tab: DetailTab): string | undefined {
  switch (tab) {
    case "people":
    case "companies":
    case "events":
      return tab;
    case "opportunities":
      return "signals";
    case "notes":
      return undefined;
  }
}

export function canonicalRegistryTitle(entityType: GraphEntityType | undefined, t: Dictionary) {
  return entityType ? entityLabel(t, entityType) : t.canonicalRegistry.allTitle;
}

export function canonicalEntityRegistrySubtitle(entity: GraphCanonicalEntity, t: Dictionary) {
  if (entity.summary?.trim()) {
    return entity.summary.trim();
  }

  return t.canonicalRegistry.projectedCounts(entity.nodeCount, entity.frameRecordCount);
}
